import { optGuestOutFromChat } from 'actions/messaging'
import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import TextArea from 'components/ReusableComponents/ManageHotel/TextArea'
import Toggle from 'components/ReusableComponents/Toggle'
import usePlausible from 'hooks/usePlausible'
import { useState } from 'react'
import { useDispatch } from 'react-redux'

import styles from './DoNotCallDialog.module.scss'

const DoNotCallDialog = ({ onClose, guestName, chatId }) => {
  const [message, setMessage] = useState('')

  const dispatch = useDispatch()

  const { postEvent, plausibleEvents } = usePlausible()

  const [isAutomatedMessageToggleChecked, setisAutomatedMessageToggleChecked] =
    useState(true)

  const [isCustomMessageToggleChecked, setisCustomMessageToggleChecked] = useState(false)

  async function handleSubmit() {
    if (isAutomatedMessageToggleChecked) {
      await dispatch(
        optGuestOutFromChat({
          chatId,
          sendUpdateText: true
        })
      )
    }

    if (isCustomMessageToggleChecked) {
      await dispatch(
        optGuestOutFromChat({
          chatId,
          sendUpdateText: true,
          customMessage: message
        })
      )
    }

    if (!isAutomatedMessageToggleChecked && !isCustomMessageToggleChecked) {
      await dispatch(
        optGuestOutFromChat({
          chatId,
          sendUpdateText: false
        })
      )
    }

    postEvent(plausibleEvents.OptOutGuest, {
      chatId
    })

    onClose()
  }

  function handleChangeAutomatedToggle(e) {
    if (e.target.checked) {
      setisAutomatedMessageToggleChecked(true)

      if (isCustomMessageToggleChecked) {
        setisCustomMessageToggleChecked(false)
      }
    } else {
      setisAutomatedMessageToggleChecked(false)
    }
  }

  function handleChangeCustomToggle(e) {
    if (e.target.checked) {
      setisCustomMessageToggleChecked(true)

      if (isAutomatedMessageToggleChecked) {
        setisAutomatedMessageToggleChecked(false)
      }
    } else {
      setisCustomMessageToggleChecked(false)
    }
  }

  return (
    <ConfirmationDialog
      title={`Add to "Do not call"`}
      theme="blacklist"
      onReject={onClose}
      positiveMessage={`Add to "Do not call"`}
      negativeMessage="Cancel"
      onConfirm={() => handleSubmit()}
    >
      <p className={styles.doNotCallDescription}>
        With this action, <strong>{guestName}</strong> will no longer receive any
        marketing messages from the property
      </p>
      <div className={styles.toggleHolder}>
        <Toggle
          label="Send an automated message while opting the guest out"
          checked={isAutomatedMessageToggleChecked}
          handleChange={handleChangeAutomatedToggle}
        />
      </div>
      <div className={styles.toggleHolder}>
        <Toggle
          label="Send a custom message"
          checked={isCustomMessageToggleChecked}
          handleChange={handleChangeCustomToggle}
        />
      </div>
      {isCustomMessageToggleChecked && (
        <div>
          <TextArea
            label="Add a message"
            placeholder="Type your message here..."
            value={message}
            onChangeValue={setMessage}
            className={styles.textArea}
          />
        </div>
      )}
    </ConfirmationDialog>
  )
}

export default DoNotCallDialog
